import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import to from 'await-to-js';
import { Book } from '../../classes/book';
import { IUser } from '../../types/datatypes';

import { UserService } from '../../core/services/data/user.service';
import { AuthorService } from '../../core/services/data/author.service';

@Component({
	selector: 'app-book-search',
	templateUrl: './book-search.component.html',
	styleUrls: ['./book-search.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class BookSearchComponent implements OnInit, OnDestroy {
	@Input() autoShowCreate: boolean;

	@Output() bookSelected = new EventEmitter<any>();

	public form: UntypedFormGroup;

	public loading = true;

	public filteredBooks: Book[];

	public showBookSearch = false;

	public defaultImageUrl = '../../../assets/img/defaults/default_book_image_400w_simple.jpg';

	public books: Book[];

	public bookId = 'book';

	public showBookShelf = false;

	public selectExistingBook = false;

	public author: IUser;

	public $author;

	public $bookStore;

	constructor(
		public userService: UserService,
		private authorService: AuthorService,
	) { }

	ngOnInit(): void {
		this.$author = this.userService.author$.subscribe((author: IUser) => {
			this.author = author;
			this.getAuthorBooks();
		});

		this.form = new UntypedFormGroup({
			book: new UntypedFormControl(),
		});
	}

	ngOnDestroy(): void {
		this.$author.unsubscribe();
	}

	get subActionText() {
		return this.selectExistingBook ? 'Add book from Amazon URL' : 'Select a book from your Bookshelf';
	}

	async getAuthorBooks() {
		const body = {
			authorId: this.author._id,
		};
		const [err, books] = await to(this.authorService.authorBooks(body)) as [any, Book[]];
		//eslint-disable-next-line no-console
		if (err) { console.log(err); }
		this.books = books;
		this.filteredBooks = books;
		this.loading = false;
	}

	searchBooks() {
		const query = this.form.get('book').value;

		if (!query.length) {
			this.showBookSearch = false;
			return;
		}

		this.showBookSearch = true;
		this.filteredBooks = this.books.filter((book) => book.title).filter((book) => book.title.toLowerCase().includes(query.toLowerCase()));
	}

	selectBook(book) {
		this.bookSelected.emit(book);
	}

	toggleBookSource() {
		this.selectExistingBook = !this.selectExistingBook;
	}
}
